import {inject, Injectable} from "@angular/core";
import {environment} from "../../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {map, Observable} from "rxjs";
import { LibDrawBaseService } from "projects/lib-ui/src/shared/base/lib-draw-base.service";
import { IDraw } from "projects/lib-ui/src/shared/interfaces/draw";

@Injectable({
  providedIn: 'root'
})
export class DrawService extends LibDrawBaseService{
  private readonly URI_API = environment.URLAPI;

  private readonly httpclient = inject(HttpClient);

  validateWinnerByBranchId(branchId: string): Observable<IDraw | null> {
    return this.httpclient.get<IDraw>(
      `${this.URI_API}Draw/validate-winner/${branchId}`
    ).pipe(map(response => {
      if (response.success) {
        return response
      }
      throw new Error(response.message || 'Failed to fetch incentive');
    }))
  }
}
